import Vue from 'vue'
import { showNotification } from '@/services/calculate'
import { socketEvents, checkEvents, costTypes } from '@/services/config'
import { formatCurrency } from '@/services/convert'
import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import IndirectCostTakeoff from '@/components/DynamicComponents/Projects/NewConstruction/IndirectCostTakeoff'
import CustomIndirectCost from '@/components/DynamicComponents/Projects/NewConstruction/CustomIndirectCost'
import axios from 'axios'

export default {
  props: [
    'projectData',
    'screenIndentifier',
    'dropdownData',
    'tableId',
    'projectModule',
    'child',
  ],
  components: {
    'indirect-cost-takeoff': IndirectCostTakeoff,
    'custom-indirect-cost': CustomIndirectCost,
  },
  data() {
    return {
      columnDefs: [],
      loader: false,
      create: new Vue(),
      formatCurrency: formatCurrency,
      list: [],
      panels: [],
      activeKey: 0,
      activeTab: 0,
      visible: false,
      estimateMethod: undefined,
      isDelete: false,
      isArchive: false,
    }
  },
  created() {
    this.isArchive = _.get(this.projectData, 'isArchive', false)
    this.$socketHub.$on('message-received', this.recievedMessage)
    this.getIndirectCost()
  },
  mounted() {
    window.addEventListener('resize', this.getWindowSize)
    this.$root.$off('addLevel')
    this.$root.$off('orderingTiles')
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowSize)
    this.$root.$off('addLevel')
    this.$root.$off('orderingTiles')
  },
  methods: {
    async getIndirectCost() {
      this.panels = []
      const types = this.dropdownData.costType.filter(i =>
        costTypes.includes(i.id),
      )
      types.forEach(element => {
        this.panels.push({
          id: element.id,
          costType: element.costType,
          isValidTakeoff: true,
          costDetails: [],
        })
      })
      this.activeKey = 0
      this.activeTab = this.panels[0].id
      await this.getIndirectTakeoffs()
    },

    async getIndirectTakeoffs() {
      this.loader = true
      Promise.all([
        this.getCustomIndirect(),
        this.getBuildingIndirect(),
        this.getProjectIndirect(),
        this.getGlobalIndirect(),
      ])
        .then(
          axios.spread((...responses) => {
            this.panels.forEach(element => {
              let data
              if (element.id === 4) {
                _.get(responses[0].data, 'result', []).forEach(response => {
                  if (!response.takeoffDetails) {
                    Object.assign(response, {
                      takeoffDetails: [],
                    })
                  }
                })
                data = _.get(responses[0].data, 'result', [])
              } else if (element.id === 5) {
                data = _.get(responses[1].data, 'result', [])
              } else if (element.id === 6) {
                data = _.get(responses[2].data, 'result', [])
              } else if (element.id === 7) {
                data = _.get(responses[3].data, 'result', [])
              }
              element.isValidTakeoff = !data.some(
                i =>
                  typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
              )
              element.costDetails = data
            })
            this.loader = false
          }),
        )
        .catch(error => {
          this.loader = false
          errorService(error)
        })
    },

    getTakeoffs(id) {
      this.isDelete = false
      this.loader = true
      instance
        .get(
          projectAPIs.project.asset.indirectCost.costDetails.list(
            this.$route.params.id,
            this.projectData.assetId,
            id,
          ),
        )
        .then(response => {
          const index = this.panels.findIndex(i => i.id === id)
          if (index > -1) {
            if (id === 4) {
              _.get(response.data, 'result', []).forEach(element => {
                if (!element.takeoffDetails) {
                  Object.assign(element, {
                    takeoffDetails: [],
                  })
                }
              })
            }
            this.panels[index].isValidTakeoff = !_.get(
              response.data,
              'result',
              [],
            ).some(
              i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
            )
            this.panels[index].costDetails = _.get(response.data, 'result', [])
          }
          this.loader = false
        })
        .catch(error => {
          this.loader = false
          errorService(error)
        })
    },

    onTabChange(value) {
      this.activeKey = value
      this.activeTab = this.panels[value].id
      this.getTakeoffs(this.activeTab)
    },

    getCustomIndirect() {
      return instance.get(
        projectAPIs.project.asset.indirectCost.costDetails.list(
          this.$route.params.id,
          this.projectData.assetId,
          4,
        ),
      )
    },

    getBuildingIndirect() {
      return instance.get(
        projectAPIs.project.asset.indirectCost.costDetails.list(
          this.$route.params.id,
          this.projectData.assetId,
          5,
        ),
      )
    },

    getProjectIndirect() {
      return instance.get(
        projectAPIs.project.asset.indirectCost.costDetails.list(
          this.$route.params.id,
          this.projectData.assetId,
          6,
        ),
      )
    },

    getGlobalIndirect() {
      return instance.get(
        projectAPIs.project.asset.indirectCost.costDetails.list(
          this.$route.params.id,
          this.projectData.assetId,
          7,
        ),
      )
    },

    checkValidTab(id, isValid) {
      const index = this.panels.findIndex(i => i.id === id)
      if (index > -1 && id === 4) {
        this.panels[index].isValidTakeoff = isValid
      }
    },

    // Socket Section Start //
    recievedMessage(message) {
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.projectSidebarUpdated) {
        this.$root.$emit('projectSideBarUpdated', message)
      }
      if (checkEvents(data.EventType)) {
        this.$root.$emit('popupUpdation', false, true, null)
      } else if (data.EventType === socketEvents.analysisSheetUpdated) {
        this.$root.$emit('popupUpdation', false, true, null)
        this.$root.$emit(`bankTakeoffs${this.projectData.assetId}`)
      } else if (
        data.EventType === socketEvents.estimateTakeoffTrendedCostUpdated
      ) {
        this.$root.$emit('popupUpdation', false, true, null)
        if (data.Result && data.Result.length > 0) {
          const group = data.Result.find(i => i.EstimateMethodUpdated)
          if (group) {
            const index = this.panels.findIndex(
              i => i.id !== 0 && i.id === group.Id,
            )
            if (index > -1) {
              this.panels[index].estimateMethod = this.estimateMethod
            }
            this.estimateMethod = undefined
            this.getTakeoffs(group.Id)
          } else if (this.isDelete) {
            this.getTakeoffs(this.activeTab)
          }
        }
      } else if (data.EventType === socketEvents.buildingGeneralUpdated) {
        this.$root.$emit('popupUpdation', false, true, null)
      } else if (data.EventType === socketEvents.error) {
        this.$root.$emit('popupUpdation', false, true, null)
        showNotification('error', 'Socket', data.Result)
      }
    },
    // Socket Section End //
  },
}
